import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {FooterComponent} from "../../components/footer/footer.component";
import {TeamActionComponent} from "../../components/team-action/team-action.component";
import {TeamsComponent} from "../../components/teams/teams.component";
import {SteeldartComponent} from "../../components/steeldart/steeldart.component";
import {EventsComponent} from "../../components/events/events.component";
import {LocationComponent} from "../../components/location/location.component";
import {IntroComponent} from "../../components/intro/intro.component";
import {OpeningComponent} from "../../components/opening/opening.component";
import {HomeHeaderComponent} from "../../components/home-header/home-header.component";
import {BlogSliderComponent} from "../../components/blog-slider/blog-slider.component";
import {EventSliderComponent} from "../../components/event-slider/event-slider.component";
import {ReviewSliderComponent} from "../../components/review-slider/review-slider.component";
import {HomeFaqComponent} from "../../components/home-faq/home-faq.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less'],
  standalone: true,
  imports: [
    FooterComponent,
    TeamActionComponent,
    TeamsComponent,
    SteeldartComponent,
    EventsComponent,
    LocationComponent,
    IntroComponent,
    OpeningComponent,
    HomeHeaderComponent,
    BlogSliderComponent,
    EventSliderComponent,
    ReviewSliderComponent,
    HomeFaqComponent
  ]
})
export class HomeComponent implements OnInit {

  constructor(private metaService: Meta, private titleService: Title,) { }

  ngOnInit(): void {
    let title = "Dart Rock Café Kassel – Darts spielen, Steeldart & E-Dart | Mi–Sa ab 17 Uhr";
    let description = "DDein Dart-Treff in Lohfelden bei Kassel: 4 Steeldart-Boards, 4 E-Dart-Automaten, tägliche Online-Turniere. Heute noch vorbeikommen – Mi bis Sa ab 17 Uhr!"
    let image = 'https://dart-rock-cafe.de/assets/images/dart-rock-cafe-magazin.jpg';
    this.titleService.setTitle(title);
    this.metaService.updateTag({name: 'description', content: description})
    this.metaService.updateTag({ property: 'og:title', content: title });
    this.metaService.updateTag({ property: 'og:description', content: description });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });
    this.metaService.updateTag({ property: 'og:url', content: 'https://dart-rock-cafe.de/' });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:image:alt', content: 'Dart Rock Café Lohfelden bei Kassel' });
    this.metaService.updateTag({ property: 'og:locale', content: 'de_DE' });
    this.metaService.updateTag({ property: 'og:site_name', content: 'Dart Rock Café' });
    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaService.updateTag({ name: 'twitter:title', content: title });
    this.metaService.updateTag({ name: 'twitter:description', content: description });
    this.metaService.updateTag({ name: 'twitter:image', content: image });
  }

}
